import { render, staticRenderFns } from "./smsHistory.vue?vue&type=template&id=f580ab98&scoped=true"
import script from "./smsHistory.vue?vue&type=script&lang=js"
export * from "./smsHistory.vue?vue&type=script&lang=js"
import style0 from "./smsHistory.vue?vue&type=style&index=0&id=f580ab98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f580ab98",
  null
  
)

export default component.exports